import * as React from 'react'
import type { SVGProps } from 'react'

interface SvgBuildingOfficeProps extends SVGProps<SVGSVGElement> {
  isActive?: boolean
}

const ACTIVE_COLOR = '#002A73'
const INACTIVE_COLOR = '#CECECE'

const VIEW_BOX = '0 0 29 28'

const SvgBuildingOffice = ({
  isActive = false,
  stroke,
  width,
  height,
  ...props
}: SvgBuildingOfficeProps) => {
  const currentColor = isActive ? ACTIVE_COLOR : INACTIVE_COLOR

  return (
    <svg
      {...props}
      width={width ?? '29'}
      height={height ?? '28'}
      viewBox={VIEW_BOX}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      {isActive && (
        <path
          opacity='0.2'
          d='M5.25 4.375V23.625H9.625V17.5H14.875V23.625H19.25V4.375H5.25Z'
          fill={ACTIVE_COLOR}
        />
      )}
      <path
        d='M2.625 23.625H27.125'
        stroke={stroke && !isActive ? stroke : currentColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.25 4.375V23.625'
        stroke={stroke && !isActive ? stroke : currentColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M19.25 23.625V4.375'
        stroke={stroke && !isActive ? stroke : currentColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M24.5 23.625V9.625'
        stroke={stroke && !isActive ? stroke : currentColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.75 8.75H10.5'
        stroke={stroke && !isActive ? stroke : currentColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14 8.75H15.75'
        stroke={stroke && !isActive ? stroke : currentColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.75 13.125H10.5'
        stroke={stroke && !isActive ? stroke : currentColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14 13.125H15.75'
        stroke={stroke && !isActive ? stroke : currentColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.625 23.625V17.5H14.875V23.625'
        stroke={stroke && !isActive ? stroke : currentColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4.375 4.375H20.125'
        stroke={stroke && !isActive ? stroke : currentColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />{' '}
      <path
        d='M19.25 9.625H25.375'
        stroke={stroke && !isActive ? stroke : currentColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default SvgBuildingOffice
